import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

// Searchable picker over existing catalogue options; allowCustom keeps free text (value = typed label).
export function SearchSelect({ value, options, onChange, placeholder = "Search…", allowCustom = false, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const cur = options.find((o) => o.value === (value ?? ""));
  const shown = cur ? cur.label : (allowCustom && value) ? value : "";
  const needle = q.trim().toLowerCase();
  const list = needle ? options.filter((o) => o.label.toLowerCase().includes(needle)) : options;
  const pick = (val) => { onChange(val); setOpen(false); setQ(""); };
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }} modal>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testid}
          className="flex h-9 w-full items-center justify-between rounded-md border border-input bg-white px-3 text-left text-sm">
          <span className={`truncate ${shown ? "text-slate-900" : "text-slate-400"}`}>{shown || placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[var(--radix-popover-trigger-width)] min-w-[240px] p-0 bg-white z-[60]">
        <Command shouldFilter={false}>
          <CommandInput value={q} onValueChange={setQ} placeholder={placeholder} data-testid={`${testid}-search`} />
          <CommandList className="max-h-60">
            <CommandEmpty>{allowCustom && q.trim() ? "No catalogue match" : "No matches"}</CommandEmpty>
            {list.map((o) => (
              <CommandItem key={o.value || "_none"} value={o.value || "_none"} onSelect={() => pick(o.value)} data-testid={`${testid}-opt-${o.value || "none"}`}>
                <Check className={`mr-2 h-4 w-4 ${o.value === (value ?? "") && cur ? "opacity-100" : "opacity-0"}`} />
                <span className="truncate">{o.label}</span>
              </CommandItem>
            ))}
            {allowCustom && q.trim() && !list.some((o) => o.label.toLowerCase() === needle) && (
              <CommandItem value={`custom:${q}`} onSelect={() => pick(q.trim())} data-testid={`${testid}-custom`}>Use “{q.trim()}” (not in catalogue)</CommandItem>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
